export default {
  settings: {
    label: '設定',
    language: {
      label: '言語',
    },
  },
}
